export default {
  ArtistReportsPage: {
    // root
  },
};
